import React, { useState } from 'react'
import { firestore } from '../../../firebase';

function AddQuiz() {

    const [name, setName] = useState("");
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");

    async function submitHandler(e) {
        e.preventDefault();
        try {
            const quizRef = firestore.collection("quiz");
            const data = {
                name
            }
            quizRef.add(data);
            setMessage("Lagt til!");
        } catch (error) {
            setError("Noe gikk galt");
        }
    }

    return (
        <form onSubmit={submitHandler}>
            <label>Tittel på quiz</label>
            <input className="form-control mb-2" value={name} onChange={e => setName(e.target.value)} />
            {error && <div className="alert alert-danger">{error} <span onClick={() => setError("")} className="float-right">Lukk</span></div>}
            {message && <div className="alert alert-success">{message} <span onClick={() => setMessage("")} className="float-right">Lukk</span></div>}       
            <button className="btn btn-success btn-block">Legg til quiz </button>
        </form>
    )

}
export default AddQuiz